import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { useIntl } from 'react-intl'

const MenuHistoryBackButton = ({ icon, onBack }) => {
  const intl = useIntl()
  return (
    <Button
      icon={icon ? icon : <ArrowLeftOutlined />}
      onClick={() => {
        onBack()
      }}
    >
      {intl.formatMessage({id: 'forms.back'})}
    </Button>
  )
}

MenuHistoryBackButton.propTypes = {
  icon: PropTypes.element,
  onBack: PropTypes.func.isRequired,
}

export default MenuHistoryBackButton
